// extracted by mini-css-extract-plugin
export var borderRadius = "_9h-4";
export var large = "_9h-3";
export var logoContainer = "_9h-0";
export var nameLogo = "_9h-2";
export var small = "_9h-1";